import { FREE_MAIL_DOMAINS, DISPOSABLE_MAIL_DOMAINS } from '@/constants/registration'

/**
 * Work-email rules for sign-up.
 *
 * The spec blocks disposable addresses outright and refuses to register a supplier on a
 * free mailbox. Both checks run here only to tell the supplier *why* the form is
 * refusing; the server makes the same call against a list this bundle does not carry.
 */
export function useEmailPolicy() {
  const domainOf = email => {
    const at = String(email ?? '').lastIndexOf('@')
    if (at === -1) return ''
    return email.slice(at + 1).trim().toLowerCase()
  }

  const isDisposable = email => DISPOSABLE_MAIL_DOMAINS.includes(domainOf(email))

  const isFreeMail = email => FREE_MAIL_DOMAINS.includes(domainOf(email))

  /**
   * @param {string} email
   * @returns {{ ok: boolean, reason: 'disposable'|'freeMail'|null }}
   */
  const classify = email => {
    const domain = domainOf(email)
    // An address that is not yet an address is not a policy failure — it is a supplier
    // halfway through typing, and telling them off mid-word helps nobody.
    if (!domain) return { ok: true, reason: null }
    if (DISPOSABLE_MAIL_DOMAINS.includes(domain)) return { ok: false, reason: 'disposable' }
    if (FREE_MAIL_DOMAINS.includes(domain)) return { ok: false, reason: 'freeMail' }
    return { ok: true, reason: null }
  }

  return { domainOf, isDisposable, isFreeMail, classify }
}
